import styled from "@emotion/styled";
import { units } from "../../../types/units";

export const SearchWrapper = styled.div`
  border-radius: 50px;
  position: relative;
  ${units({
    backgroundColor: "white",
  })};

  &.small {
    .form-control {
      height: 40px;
    }
    button {
      padding: 7px 9px;
      margin: 0px 4px 0 0;
      .MuiIconButton-label {
        width: 20px;
      }
    }
  }
`;

export const SearchInner = styled.div`
  border: 1px solid;
  border-radius: 50px;

  ${units({
    borderColor: "grey",
  })};

  .form-control {
    border: none;
    width: 100%;
    height: 50px;
    border: none;
    padding: 0 20px 0 1.75rem;
    border-radius: 50px;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
  }

  button {
    position: absolute;
    right: 0;
    top: 2px;
  }

  input {
    font-family: ${(props) => props.theme.fontFamily.primary};
  }
`;
